import emptyGrid from './emptyGrid.json';
import uqlGrid from './UqlGrid.json';
import uqlPaginatedGrid from './uqlPaginatedGrid.json';
import rawValues from './RawValues.json';
import valueFormatting from './ValueFormatting.json';
import customValueFormatting from './CustomValueFormatting.json';
import cellType from './CellType.json';

export default [emptyGrid, uqlGrid, uqlPaginatedGrid, rawValues, valueFormatting, customValueFormatting, cellType];
